<script setup>
import { ref, onMounted, watch, useSlots } from 'vue'

const emit = defineEmits(['input:updateModel', 'selectSegment'])

defineProps({
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md', 'lg'].includes(value),
  },
})

const model = defineModel({ type: Number })

const selectedIndex = ref(0)
const slots = useSlots()
const segments = ref([])

const selectSegment = i => {
  selectedIndex.value = i
  emit('selectSegment', i)
}

onMounted(() => {
  segments.value = slots.default().map((vnode, index) => ({
    title: vnode.props?.title || `Segment ${index + 1}`,
    icon: vnode.props?.icon || '',
    content: vnode,
  }))

  if (model.value) {
    selectedIndex.value = model.value
  }
})

watch(selectedIndex, newVal => {
  emit('update:modelValue', newVal)
})

watch(
  () => model.value,
  newVal => {
    selectSegment(newVal)
  },
)
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      class="border-neutral-40 bg-neutral-10 text-neutral-60 inline-flex w-fit flex-row items-center rounded-lg border-[0.5px] p-1"
      :class="{
        'p-[2px] text-sm': size === 'sm',
        'p-[6px] text-sm': size === 'md',
        'p-[4px] text-base': size === 'lg',
      }"
    >
      <button
        v-for="(item, index) in segments"
        :key="index"
        @click="selectSegment(index)"
        :class="[
          {
            'border-neutral-40 text-primary-90 rounded-lg border-[0.5px] bg-white shadow-md':
              selectedIndex === index,
            'px-2 py-1': size === 'sm',
            'px-4 py-2': size === 'md',
            'px-4 py-2.5': size === 'lg',
          },
        ]"
        class="flex cursor-pointer items-center px-4 py-[10px] leading-normal font-semibold whitespace-nowrap"
      >
        <ImoIcon v-if="item.icon" :name="item.icon" :size="20" class="mr-2" />
        {{ item.title }}
      </button>
    </div>
    <div class="border-neutral-20 relative flex w-full flex-col rounded-xl border p-4 break-words">
      <component :is="segments[selectedIndex]?.content" />
    </div>
  </div>
</template>
